import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { IUomTableRow } from 'bom/types';
import { Select } from 'core/components';

export const AssignUomCell = ({
  value,
  setValue,
  data,
}: ICellRendererParams<IUomTableRow, string>) => {
  const { t } = useTranslation();

  // Group header rows (when grouping by UOM) have no data — render blank, not an empty Select.
  if (!data) {
    return null;
  }

  const onUomChange = (_, uom: string) => {
    if (!uom) {
      return;
    }

    setValue(uom);
  };

  const uomOptions = (data.allowedUoms ?? []).map((option) => ({ value: option, name: option }));

  return (
    <Select
      value={value || ''}
      placeholder={t('placeholderChooseUom')}
      onChange={onUomChange}
      options={uomOptions}
      getLabel={(option) => option.name}
    />
  );
};
